import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ViewRequestData.css';

interface Request {
	id: number;
	startDate: string;
	endDate: string;
	dropdown1: string;
	dropdown2: string;
	description: string;
	status: string;
	userId: string;
}

const ViewRequestData = () => {
	const { id } = useParams();
	const [request, setRequest] = useState<Request | null>(null);
	const navigate = useNavigate();

	useEffect(() => {
		const storedRequests = localStorage.getItem('requests');
		const requests: Request[] = storedRequests ? JSON.parse(storedRequests) : [];
		const foundRequest = requests.find((r) => r.id === parseInt(id || '', 10));
		setRequest(foundRequest || null);
	}, [id]);

	const handleBack = () => {
		navigate('/opportunity-analytics');
	};

	return (
		<div className="view-request-container">
			{request ? (
				<div className="view-request-card">
					<div className="view-request-header">
						<h3>Request Details</h3>
					</div>
					<div className="view-request-body">
						<div>
							<p>
								<strong>Start Date:</strong> {request.startDate}
							</p>
							<p>
								<strong>End Date:</strong> {request.endDate}
							</p>
							<p>
								<strong>Dropdown 1:</strong> {request.dropdown1}
							</p>
							<p>
								<strong>Dropdown 2:</strong> {request.dropdown2}
							</p>
							<p>
								<strong>Description:</strong> {request.description}
							</p>
							<p>
								<strong>Status:</strong> {request.status}
							</p>
						</div>
						<button className="view-request-button" onClick={handleBack}>
							Back to Submit Form
						</button>
					</div>
				</div>
			) : (
				<p className="view-request-loading">Loading request details...</p>
			)}
		</div>
	);
};

export default ViewRequestData;
